import script from "./History.vue?vue&type=script&setup=true&lang=js"
export * from "./History.vue?vue&type=script&setup=true&lang=js"

import "./History.vue?vue&type=style&index=0&id=43336289&scoped=true&lang=css"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43336289"]])

export default __exports__